import React, { ReactNode } from 'react';
import { User } from '../../../interfaces/backend/User';
import { BuildCodeParams } from './CodeSample';
import { CodeType } from '../CodeType';
import Paragraph from 'antd/lib/typography/Paragraph';
import CodeBlock from '../CodeBlock';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';

export default class BackendPythonSample extends BackendCodeSample {
  name = 'Python';
  language = 'python';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = '#';

  buildCode({
    environment,
    notification,
    user,
    mergeTags
  }: BuildCodeParams): ReactNode {
    const pipInstall = 'pip install notificationapi_python_server_sdk';

    const code = `import asyncio 
from notificationapi_python_server_sdk import notificationapi

async def send_notification():
    notificationapi.init(
        "${environment.clientId}",  # clientId
        "${environment.clientSecret}" # clientSecret
    )

    await notificationapi.send({
        "notificationId": "${notification.notificationId}",
        "user": {
          ${this.buildUserObjectString(user, '\n          ')}
        },
        "mergeTags": ${
          JSON.stringify(mergeTags, null, 12).slice(0, -1) + '        }'
        }
    })

asyncio.run(send_notification())`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          To use the Python NotificationAPI SDK, you must install it with pip:
        </Paragraph>
        <CodeBlock language="bash" code={pipInstall} />
        <Paragraph>
          Once the NotificationAPI SDK is installed you can use the following
          code to send your first notification:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `"id": "${user.id}"`,
      email: `"email": "${user.email}"`,
      number: {
        value: `"number": "${user.number}"`,
        comment: 'Replace with your phone number'
      }
    };
  }
}
